export default "__VITE_ASSET__qyIPFEpL__"